import React from 'react'
import CardBlock from '../cardBlock'
import { CampaignBarWrap, CampaignList } from './style'

const TextGrid = ({ row }) => {
  const data = [
    {
      id:'OrganicEarnedInteractions',
      value: row.EarnedOrganicReach,
    },
    {
      id:'PaidInteraction',
      value: row.PaidReach,
    },
    {
      id:'NewsBlogPostsVideos',
      value: row.Coverage,
    },
    {
      id:'Posts',
      value: row.Engagement,
    },
  ]

  return (
    <CampaignBarWrap>
      {data.map((item) => {
        if (+item?.value === 0) return false
        return (
          <CardBlock
            id={item.id}
            value={item.value} 
            type='inline'
          />
        )
      })}
    </CampaignBarWrap>
  )
}

export default TextGrid
